import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import 'slick-carousel'
import 'slick-carousel/slick/slick.scss'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        seeMore: String,
        seeLess: String,
    }

    connect() {
        const $carousel = $(this.element).find('.combined-reviews-carousel')

        if ($carousel.length > 0) {
            $carousel.slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            prevArrow: false,
                            dots: false,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            prevArrow: false,
                            centerMode: false,
                        },
                    },
                ],
            })

            $(this.element).find('.review-comment').each(function () {
                const $this = $(this)
                const $wrapper = $this.closest('.review-comment-wrapper')
                const $readMore = $wrapper.find('.review-read-more')
                const fullText = $this.data('full-text')

                if (fullText && fullText.length > 156) {
                    const truncatedText = fullText.substring(0, 156) + '...'
                    $this.text(truncatedText)
                    $wrapper.addClass('has-more')
                    $readMore.removeClass('d-none')
                }
            })

            const seeMoreText = this.seeMoreValue
            const seeLessText = this.seeLessValue

            $(this.element).on('click', '.review-read-more', function (e) {
                e.preventDefault()
                e.stopPropagation()

                const $this = $(this)
                const $wrapper = $this.closest('.review-comment-wrapper')
                const $commentSpan = $wrapper.find('.review-comment')
                const fullText = $commentSpan.data('full-text')
                const isExpanded = $wrapper.hasClass('expanded')

                if (isExpanded) {
                    const truncatedText = fullText.substring(0, 156) + '...'
                    $commentSpan.text(truncatedText)
                    $wrapper.removeClass('expanded').addClass('has-more')
                    $this.text(seeMoreText)
                } else {
                    $commentSpan.text(fullText)
                    $wrapper.removeClass('has-more').addClass('expanded')
                    $this.text(seeLessText)
                }
            })
        }
    }
}
